<template>
  <div class="filters--list">
    <v-row>
      <v-col class="pt-0 pr-1" cols="12" sm="12" md="6" lg="3">
        <FilterSearch :fetchData="fetchData" />
      </v-col>
      <v-col class="pt-0 px-1" cols="12" sm="12" md="6" lg="3">
        <FilterSelect :fetchData="fetchData" :items="items" label="Status" type="status" />
      </v-col>
      <v-col class="pt-0 px-1" cols="12" sm="12" md="6" lg="3">
        <FilterAutocomplete
          :label="$t('appointment.filters.type')"
          :fetchData="fetchData"
          :items="appointmentTypes"
          :item-text="(item) => $t(`type.${item.value}`)"
          type="serviceTypes"
          multiple
        />
      </v-col>
      <v-col class="pt-0 pl-1" cols="12" sm="12" md="6" lg="3">
        <FilterAutocomplete
          :label="$t('appointmentDashboard.tag.tags')"
          :fetchData="fetchData"
          :items="tags"
          value="id"
          item-text="name"
          type="tagsIds"
          multiple
        />
      </v-col>
    </v-row>
    <span class="d-block my-2" />
    <v-row>
      <v-col class="pt-0 pr-1" cols="12" lg="6">
        <FilterDatesRange
          :fetchData="fetchData"
          :customStartDate="true"
          :maxDate="maxDate"
          ref="filterDatesRange"
          startDateProp="startDate"
          endDateProp="endDate"
          class="mt-0"
        />
      </v-col>
      <v-col class="pt-0 px-1" cols="12" sm="12" md="6" lg="3">
        <FilterAutocomplete
          label="Classificar por"
          :fetchData="fetchData"
          :items="sortBy"
          type="sortBy"
          multiple
        />
      </v-col>
      <v-col class="pt-0 pl-1" cols="12" sm="12" md="6" lg="3">
        <FilterAutocomplete
          :label="$t('filters.orderBy')"
          :fetchData="fetchData"
          :items="orderBy"
          type="orderBy"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FilterSelect from '@/components/filters/FilterSelect'
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDatesRange from '@/components/filters/FilterDatesRange'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'

import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'QAAppointmentDashboardFilters',

  components: {
    FilterSelect,
    FilterSearch,
    FilterDatesRange,
    FilterAutocomplete,
  },

  methods: {
    ...mapActions(['fetchDashboardAppointments', 'fetchDashboardAppointmentsCount', 'fetchAppointmentTypes']),

    fetchData() {
      this.fetchDashboardAppointments()
      this.fetchDashboardAppointmentsCount()
    }
  },

  computed: {
    ...mapGetters(['filters', 'appointmentTypes', 'tags']),

    minDate() {
      return moment().add(-100, 'days').toISOString()
    },

    currentFilters() {
      return this.filters
    },

    selectedStartDate() {
      return this.currentFilters ? this.currentFilters.startDate : null
    },

    selectedEndDate() {
      return this.currentFilters ? this.currentFilters.endDate : null
    }
  },

  watch: {
    currentFilters(newValue) {
      if (newValue.startDate) {
        this.maxDate = moment(newValue.startDate).add(100, 'days').toISOString()
        if (newValue.endDate && moment(newValue.endDate).diff(newValue.startDate, 'days') <= 100) {
          this.$refs.filterDatesRange.endDateShow = moment(newValue.endDate).format('DD/MM/YYYY')
        } else {
          this.$refs.filterDatesRange.endDateShow = moment(this.maxDate).format('DD/MM/YYYY')
        }
      }
    },
  },

  data() {
    return {
      items: [
        {
          text: this.$t('status.SCHEDULED'),
          value: 'SCHEDULED',
        },
        {
          text: this.$t('status.DONE'),
          value: 'DONE',
        },
        {
          text: this.$t('status.CANCELED'),
          value: 'CANCELED',
        },
      ],
      orderBy: [
        { value: 'ASC', name: this.$t('filters.older') },
        { value: 'DESC', name: this.$t('filters.newer') },
      ],
      sortBy: [
        { value: 'APPOINTMENT_CODE', name: this.$t('filters.appointmentCode') },
        { value: 'REALTY_CODE', name: this.$t('filters.realtyCode') },
        { value: 'STATUS', name: this.$t('filters.status') },
        { value: 'DATE', name: this.$t('filters.appointmentDate') },
        { value: 'HOST_NAME', name: this.$t('filters.hostName') },
      ],
      maxDate: moment().add(100, 'days').toISOString()
    }
  },

  mounted() {
    this.fetchAppointmentTypes()
    this.$refs.filterDatesRange.startDateShow = moment(this.minDate).format('DD/MM/YYYY')
    this.$refs.filterDatesRange.endDateShow = moment().format('DD/MM/YYYY')
  }
}
</script>
